<template>
  <ComplianceLayout page="disclaimer">
    <h1>Disclaimer & Compliance</h1>
    <h2>Independent Website</h2>
    <p>This website is an independent informational platform created for educational and reference purposes.</p>
    <p>We are not the official developers, publishers, or distributors of GB WhatsApp.</p>
    <h2>No Affiliation</h2>
    <p>This website is not affiliated with, endorsed by, sponsored by, or officially connected to:</p>
    <ul>
      <li>WhatsApp Messenger</li>
      <li>Meta Platforms, Inc.</li>
      <li>Any official WhatsApp organization</li>
    </ul>
    <p>“WhatsApp” is a registered trademark of Meta Platforms, Inc.</p>
    <h2>Informational Use Only</h2>
    <p>The information provided on this website is intended for:</p>
    <ul>
      <li>Educational content</li>
      <li>Tutorials and guides</li>
      <li>General app information</li>
      <li>Version discussions</li>
    </ul>
    <p>We do not claim ownership of any third-party applications mentioned on this website.</p>
    <h2>No Affiliate Relationship</h2>
    <p>This website is not an affiliate partner of GB WhatsApp or any related application provider.</p>
    <p>We do not receive commissions for downloads, installations, or external app references.</p>
    <h2>Third-Party Application Notice</h2>
    <p>GB WhatsApp is a modified third-party application and is not an official version of WhatsApp Messenger.</p>
    <p>Users should understand the possible risks of using unofficial apps, including:</p>
    <ul>
      <li>Account restrictions</li>
      <li>Privacy concerns</li>
      <li>Compatibility problems</li>
      <li>Security risks</li>
    </ul>
    <p>Users are responsible for their own installation and usage decisions.</p>
    <h2>Copyright Concerns</h2>
    <p>If you believe that any content on this website violates copyright or intellectual property rights, please contact us for review.</p>
    <p>Valid requests will be processed as quickly as possible.</p>
  </ComplianceLayout>
</template>

<script>
import ComplianceLayout from '@/components/ComplianceLayout.vue';

export default {
  name: 'DisclaimerPage',
  components: {
    ComplianceLayout,
  },
};
</script>
